<template>
  <div>
    <!-- General Information card -->
    <b-card class="mt-2">
      <b-card-title>Your Details</b-card-title>
      <!-- form -->
      <b-form>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label="Full Name"
              label-for="account-fullname"
            >
              <b-form-input
                v-model="optionsLocal.fullName"
                placeholder=""
                name="fullname"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label="Telephone Number"
              label-for="account-telephone"
            >
              <b-form-input
                v-model="optionsLocal.telephone"
                name="telephone"
                placeholder=""
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-2 mr-1"
              :disabled="generalLoading"
              @click="submitGeneralChange"
            >
              <b-spinner
                v-if="generalLoading"
                small
              />
              <span v-else>Save changes</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <account-setting-company
      :fca-number="generalData.fca"
      :company-address="generalData.company"
    />
  </div>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BCardTitle, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import AccountSettingCompany from './AccountSettingCompany.vue'

export default {
  components: {
    AccountSettingCompany,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      optionsLocal: JSON.parse(JSON.stringify(this.generalData)),
      profileFile: null,
      generalLoading: false,
    }
  },
  watch: {
    generalData: {
      handler(newVal) {
        this.optionsLocal = JSON.parse(JSON.stringify(newVal))
      },
    },
  },
  methods: {
    resetForm() {
      this.optionsLocal = JSON.parse(JSON.stringify(this.generalData))
    },
    submitGeneralChange() {
      // Reset flags
      this.generalLoading = true

      this.$http
        .get('account.cfc', {
          params: {
            method: 'detailschange',
            yourname: this.optionsLocal.fullName,
            telephone: this.optionsLocal.telephone,
          },
        })
        .then(response => {
          this.generalLoading = false

          if (response.data.success) {
            this.$bvToast.toast('Your general information has been updated successfully', {
              title: 'Success',
              variant: 'success',
              solid: true,
            })
          } else {
            this.$bvToast.toast('Your general information could not be updated. Please try again', {
              title: 'Failed',
              variant: 'danger',
              solid: true,
            })
          }
        })
        .catch(() => {
          this.generalLoading = false
          this.$bvToast.toast('An error occurred. Please try again', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
  setup() {
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl)

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    }
  },
}
</script>
